import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, InputAdornment, CircularProgress } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

import LogoImg from '../assets/crmimg.png';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Loader state

  const handleLogin = () => {
    setLoading(true); // १. Loader chalu kara

    // Mock Login Process (Tumchi API ithe call kara)
    setTimeout(() => {
      setLoading(false); // २. Loader band kara
      toast.success('Login successful', {
        duration: 3000,
        position: 'top-right',
        style: {
          background: '#2ecc71', // Image madhe dakhvalya pramane green color
          color: '#fff',
          fontWeight: 'bold',
        },
      });

      // ३. Thodya velane Dashboard var pathva jene karun toast disel
      setTimeout(() => {
        navigate('/dashboard');
      }, 1000);
    }, 2000); 
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f4f7fa', p: { xs: 2, md: 0 } }}>
      <Toaster /> {/* Toast notification sathi container */}

      {/* image_a27d71.png madhe dakhvalya pramane Full Page Loader */}
      {loading && (
        <Box sx={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          bgcolor: 'rgba(255, 255, 255, 0.8)', // White semi-transparent overlay
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(3px)'
        }}>
          {/* Custom Red Spinner (image_a27d71.png sathi) */}
          <CircularProgress size={60} sx={{ color: '#ff0000' }} /> 
        </Box>
      )}

      <Paper elevation={10} sx={{
        width: '100%', maxWidth: 950, borderRadius: '20px', overflow: 'hidden',
        display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: { md: '550px' }
      }}>

        {/* डावी बाजू */}
        <Box sx={{ flex: 1, bgcolor: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, borderRight: { md: '1px solid #f0f0f0' } }}>
          <img src={LogoImg} alt="Logo" style={{ width: '100%', maxWidth: '280px', height: 'auto' }} />
          <Typography variant="h6" sx={{ mt: 3, fontWeight: 700, color: '#333', textAlign: 'center' }}>
            वरदविनायक रिअल इन्फ्रा प्रा. लि.
          </Typography>
        </Box>

        {/* उजवी बाजू */}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 4, md: 6 }, bgcolor: '#ffffff' }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: '#e65100', mb: 1 }}>Welcome Back!</Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>Welcome, Login to Your Account.</Typography>

         <TextField
            fullWidth
            placeholder="User Name"
            margin="normal"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineOutlinedIcon sx={{ color: '#9e9e9e' }} />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',

                  // १. डीफॉल्ट आणि होव्हर बॉर्डर
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ced4da",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e65100", // माऊस नेल्यावर ऑरेंज
                  },

                  // २. क्लिक केल्यावर (Focus) ऑरेंज बॉर्डर
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e65100",
                    borderWidth: "2px" // थोडी ठळक बॉर्डर हवी असल्यास
                  },

                  // ३. तुमचा ऑटोफिल वाला कोड
                  "& input:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 1000px white inset",
                  }
                }
              }
            }}
          />

          {/* Password Field */}
          <TextField
            fullWidth
            placeholder="Password"
            type="password"
            margin="normal"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon sx={{ color: '#9e9e9e' }} />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',

                  // १. डीफॉल्ट आणि होव्हर बॉर्डर
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#ced4da",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e65100", // माऊस नेल्यावर ऑरेंज
                  },

                  // २. क्लिक केल्यावर (Focus) ऑरेंज बॉर्डर
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e65100",
                    borderWidth: "2px" // थोडी ठळक बॉर्डर हवी असल्यास
                  },

                  // ३. तुमचा ऑटोफिल वाला कोड
                  "& input:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 1000px white inset",
                  }
                }
              }
            }}
          />

          <Button
            fullWidth variant="contained"
            onClick={handleLogin} // Call handleLogin instead of direct navigate
            startIcon={<LoginIcon />}
            disabled={loading} // Loading suru astana button disable kara
            sx={{
              mt: 4, py: 1.5, borderRadius: '25px', bgcolor: '#e65100',
              textTransform: 'none', fontSize: '1rem', fontWeight: 600,
              '&:hover': { bgcolor: '#d50000' }
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;